import PropTypes from 'prop-types';
import { DB_PREFIX } from './constants';

export default PropTypes.shape({
  [DB_PREFIX]: PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.shape({
      postCode: PropTypes.PropTypes.string,
      country: PropTypes.PropTypes.string,
      town: PropTypes.PropTypes.string,
      address01: PropTypes.PropTypes.string,
      address03: PropTypes.PropTypes.string,
    }),
  }),
});
